<div *ngIf="models && models.length > 0" class="mt-3 mb-3" role="complementary">
  <p-card *ngFor="let model of models; index as cardIndex" id="{{model.baseId}}-card">
      <p-header id="{{model.baseId}}-header">
        <h4>{{model.title}}</h4>
      </p-header>
      <div id="{{model.baseId}}-body" [innerHTML]="model.body" tabindex="0"></div>
      <ng-template pTemplate="footer">
        <p-button id="createNewsButton" type="button" label="View" styleClass="p-button p-button-outlined p-button-sm" (click)='selectedModel=model'></p-button>
      </ng-template>
  </p-card>
</div>

<p-dialog id="news-announcement-dialog" [header]="selectedModel.title" *ngIf="selectedModel"
          [(visible)]="!!selectedModel" [modal]="true" [closable]="true" [style]="{width: '60vw'}"
          [closeOnEscape]="true" (onHide)="selectedModel = undefined" [dismissableMask]="true" [closeAriaLabel]="'Close'">
  <p-card [styleClass]="'white'" id="news-card-modal">
    <div [innerHTML]="selectedModel?.body" tabindex="0"></div>
  </p-card>
</p-dialog>
